/**
 * @description upload video info model
 * @date 2019-04-12
 * @author jywang
 */
import React, { PureComponent } from 'react';
import { UploadSchedule } from '../UploadSchedule';
import tool from '@util/tool';
import { ResourceInfo } from '../ResourceInfo';
import { observer } from 'mobx-react/custom';
import { inject } from 'mobx-react';
import { Button } from 'antd';
import toast from '@util/toast';
import './index.scss';
import moment from 'moment';
const currentEditPicId = tool.getQueryString('id');
@inject('store')
@observer
class UploadInfo extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            hasClickSubmit: false,
            isLoading: false
        };
    }
    public render() {
        const { store, fileInput, coverUpload } = this.props;
        const { hasClickSubmit, isLoading } = this.state;
        const size = store.createVideoState.videoSize;
        const progressCount = store.createVideoState.progressCount;
        const name = store.createVideoState.videoName;
        const cover = store.createVideoState.videoCover;
        return (
            <div className="upload-info-box">
                <div className="upload-schedule-box">
                    <UploadSchedule
                        {...store.createVideoState}
                        status={store.createVideoState.uploadStatus}
                        fileInput={fileInput}
                        delVideo={this.delVideo}
                        name={name}
                        size={size}
                        progress={progressCount}
                    />
                    <ResourceInfo
                        status={store.createVideoState.uploadStatus}
                        coverUpload={coverUpload}
                        desc={store.createVideoState.videoDesc}
                        title={store.createVideoState.title}
                        descChange={this.descChange}
                        titleChange={this.titleChange}
                        groupIdChange={this.groupIdChange}
                        groupId={store.createVideoState.groupId}
                        releaseTypeChange={this.releaseTypeChange}
                        releaseTimeChange={this.releaseTimeChange}
                        releaseType={store.createVideoState.releaseType}
                        releaseTime={store.createVideoState.releaseTime}
                        cover={cover}
                        recommendationImgs={store.createVideoState.frames}
                        setCover={this.setCover}
                        isLoading={isLoading}
                    />
                </div>
                <div className="upload-info-submit-button-box">
                    <Button
                        disabled={
                            hasClickSubmit ||
                            isLoading ||
                            store.createVideoState.uploadStatus !== 'done'
                        }
                        onClick={this.videoSubmit}
                        type="primary">
                        发布视频
                    </Button>
                </div>
            </div>
        );
    }
    public delVideo = () => {
        const { store } = this.props;
        store.createVideoState.set_video(null);
        store.createVideoState.set_uploadStatus(null);
        store.createVideoState.set_videoCover(null);
        store.createVideoState.set_progress(0);
        store.createVideoState.set_localPath(null);
        store.createVideoState.keyValueChange('frames', ['', '', '', '']);
    };
    public descChange = e => {
        const desc = e.target.value;
        const { store } = this.props;
        store.createVideoState.set_videoDesc(desc);
    };
    public titleChange = e => {
        const desc = e.target.value;
        const { store } = this.props;
        store.createVideoState.keyValueChange('title', desc);
    };
    public setCover = url => {
        try {
            const { store } = this.props;
            const { isLoading } = this.state;
            if (isLoading) {
                return;
            }
            this.setState({
                isLoading: true
            });

            // 如果传入的是 File 对象
            if (url instanceof File) {
                this.props.getStsWrite(
                    url,
                    data => {
                        store.createVideoState.set_videoCover(data.url);
                        this.setState({ isLoading: false });
                    }
                );
            } else if (url.startsWith('http://') || url.startsWith('https://')) {
                // 如果是 HTTP/HTTPS URL
                store.createVideoState.set_videoCover(url);
                this.setState({ isLoading: false });
            } else {
                // 否则作为 dataURL 处理
                this.props.getStsWrite(
                    tool.dataURLtoFile(url, 'video_frame.jpg'),
                    data => {
                        store.createVideoState.set_videoCover(data.url);
                        this.setState({ isLoading: false });
                    }
                );
            }
        } catch (error) {
            this.setState({ isLoading: false });
        }
    };
    public groupIdChange = val => {
        const { store } = this.props;
        store.createVideoState.set_groupId(val);
    };
    public releaseTypeChange = val => {
        const { store } = this.props;
        store.createVideoState.set_release_type(val);
    };
    public releaseTimeChange = val => {
        const { store } = this.props;
        store.createVideoState.set_release_time(val);
    };
    public videoSubmit = () => {
        this.setState({
            hasClickSubmit: true
        });
        const { store } = this.props;
        const {
            videoDesc,
            pixel,
            duration,
            videoId,
            video,
            videoCover,
            groupId,
            releaseTime,
            title
        } = store.createVideoState;
        if (videoDesc && videoDesc.length > 10000) {
            toast.error('视频简介不可超出10000字');
            this.setState({
                hasClickSubmit: false
            });
            return;
        }
        // if (!title) {
        //     toast.error('请输入标题');
        //     this.setState({
        //         hasClickSubmit: false
        //     });
        //     return;
        // }
        if (!videoCover) {
            toast.error('请上传封面图');
            this.setState({
                hasClickSubmit: false
            });
            return;
        }
        const info: any = {};
        info.videoRes = pixel;
        info.duration = duration;
        info.cover = videoCover;
        info.videoId = videoId;
        info.videoUrlSource = video;
        info.groupId = groupId;
        info.title = title || '';
        if (releaseTime) {
            if (moment(releaseTime).valueOf() < Date.now()) {
                toast.error('仅支持选择此刻之后14天时间');
                this.setState({
                    hasClickSubmit: false
                });
                return;
            }
            info.releaseTime = releaseTime;
        }
        info.content = tool.trimStr(videoDesc);
        console.log(info);
        if (currentEditPicId) {
            store.addPics
                .edit_v2_request({
                    post: { video: info },
                    productId: currentEditPicId
                })
                .then(res => {
                    console.log('发布成功====>', res);
                    window.location.href = '/video';
                })
                .catch(err => {
                    toast.error(err.msg);
                });
        } else {
            store.videoRelease
                .set_v2({ post: { video: info } })
                .then(res => {
                    window.location.href = '/video';
                    console.log('视频发布成功===============>', res);
                })
                .catch(error => {
                    console.log('发布视频失败================>', error);
                    toast.error(error.msg);
                    this.setState({
                        hasClickSubmit: false
                    });
                });
        }
    };
}
export default UploadInfo;
